import { TextBox } from "./components/TextBox";
import React from "react";
import { Grid, IconButton, MenuItem } from "@mui/material";
import BreadcrumbNav from "./components/BreadcrumbNav";
import CustomNavigationBar from "./components/CustomAppBar/CustomNavigatioBar";
import "../src/style.css";
import Box from "@mui/material/Box";
import CustomAccordion from "./components/CustomAccordion";
import FormTable from "./components/FormTable1/FormTable";
import axios from "axios";
import ColumnHeader from "./components/ColHeader";
import OverallSection1 from "./components/RTL/estimatedCost/OverallAccordian1";
import PotentialAccordian2  from "./components/RTL/estimatedCost/PotentialAccordian2";

import DisabledTextField from "./components/DisabledTextField";
import {
  CUSTOM_APP_BAR_TEXT,
  PATH,
  RENTAL_TEXTILE_LAUNDRY,
} from "./constants";
import Dropdown from "./components/Dropdown";
import { useState } from "react";
import RemoveCircleOutlineOutlinedIcon from "@mui/icons-material/RemoveCircleOutlineOutlined";
import ControlPointOutlinedIcon from "@mui/icons-material/ControlPointOutlined";
import CustomAutocomplete from "./components/CustomAutocomplete";
import GenericForm from "./components/GenericForm";
import OutputTable from "./components/OutputTable";
import EnergyAccordian from "./components/RTL/reducedEnergy/EnergyAccordian";
import FootprintAccordian from "./components/RTL/reducedEnergy/FootprintAccordian";
import AmountOfChemAccordian from "./components/RTL/environementalImpact/AmountOfChemAccordian";
import Co2Emission from "./components/RTL/environementalImpact/Co2Emission";
import GetAppIcon from '@mui/icons-material/GetApp';
import Tooltip from '@mui/material/Tooltip';
import generatePDF from "./utils/generatePdf";

const RentalTextileLaundry = () => {
  const paths = [
    { url: "/home", label: RENTAL_TEXTILE_LAUNDRY.HOME_LABEL },
    {
      url: PATH.userProfileSelectionPath,
      label: RENTAL_TEXTILE_LAUNDRY.USER_PROFILE_SELECTION_LABEL,
    },
    {
      url: PATH.rentalTextileLaundryPath,
      label: RENTAL_TEXTILE_LAUNDRY.RENTAL_TEXTILE_LAUNDRY_LABEL,
    },
  ];

  const [tabValue, setTabValue] = React.useState(0);
  const tabTexts = RENTAL_TEXTILE_LAUNDRY.tabTexts;
  const currentTexts = tabTexts[tabValue] || {};
  


  const handleTabChange = (newValue) => {
    setTabValue(newValue);
  };

  return (

    <div className="padding-l-r" id="pdf-content">
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "end" }}>
        <BreadcrumbNav paths={paths} />
        <Tooltip title="Download PDF">
          <IconButton
            className="pdf-download-button"
            onClick={generatePDF}
          >
            <GetAppIcon />
          </IconButton>
        </Tooltip>
      </div>
      <CustomNavigationBar onTabChange={handleTabChange} 
        label1={CUSTOM_APP_BAR_TEXT.ESTIMATED_COST}
        label2={CUSTOM_APP_BAR_TEXT.ENERGY_AND_OPERATIONAL_FOOTPRINT}
        label3={CUSTOM_APP_BAR_TEXT.ENVIRONMENT}
      />
      
      <TextBox
        className="info-text"
        p1={currentTexts.p1}
        p2={currentTexts.p2}
        p3={currentTexts.p3}
      />

      {(tabValue === 0) && (
        <>
        <OverallSection1 />
        <PotentialAccordian2 />
        </>

      )}
      {(tabValue === 1) && (
        <>
        <EnergyAccordian />
        <FootprintAccordian/ >
        </>  
      )}
      {(tabValue === 2) && (
        <>
        <AmountOfChemAccordian/>
        {/* <Co2Emission/> */}
        </>
        )}
    </div>
  
  );
};




export default RentalTextileLaundry;
